/** Bosqich kirish ekrani (demo `step` → intro). */
import { t, tn } from '../../../i18n';
import { next, STAGES, type Step } from '../engine';
import { Frame } from './common';

export function IntroStep({ s }: { s: Step }) {
  const stage = s.stage ?? 0, g = STAGES[stage]!;
  return (
    <Frame foot={<button className="btn" id="nxt" autoFocus onClick={next}>{t('Boshlash')}</button>}>
      <div className="col g16" style={{ flex: 1, justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
        <span className="badge" style={{ width: 72, height: 72, borderRadius: 24, fontSize: 28, background: 'var(--primary-soft)', color: 'var(--primary-ink)' }}>{stage + 1}</span>
        <span className="cap">{tn('#-bosqich', stage + 1)}</span>
        <h1 className="h2">{t(g.n)}</h1>
        <p className="sub" style={{ maxWidth: 300 }}>{t(g.d)}</p>
        <span className="soon" style={{ background: 'var(--primary-soft)', color: 'var(--primary-ink)' }}>{tn('# ta soʻz', s.count ?? 0)}</span>
      </div>
    </Frame>
  );
}
